import { Storage } from './index';

import { UserRole, PlanTenant } from '@/features/auth';

export const Permissions = {
    tenantEdit: {
        id: 'tenantEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    tenantDestroy: {
        id: 'tenantDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    planEdit: {
        id: 'planEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    planRead: {
        id: 'planRead',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    userEdit: {
        id: 'userEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    userDestroy: {
        id: 'userDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    userCreate: {
        id: 'userCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    userImport: {
        id: 'userImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    userRead: {
        id: 'userRead',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    userAutocomplete: {
        id: 'userAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    auditLogRead: {
        id: 'auditLogRead',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    settingsEdit: {
        id: 'settingsEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.settingsBackgroundImages, Storage.settingsLogos]
    },
    workspaceImport: {
        id: 'workspaceImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    workspaceCreate: {
        id: 'workspaceCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.workspacePhoto]
    },
    workspaceEdit: {
        id: 'workspaceEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.workspacePhoto]
    },
    workspaceDestroy: {
        id: 'workspaceDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.workspacePhoto]
    },
    workspaceRead: {
        id: 'workspaceRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    workspaceAutocomplete: {
        id: 'workspaceAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    projectImport: {
        id: 'projectImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    projectCreate: {
        id: 'projectCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    projectEdit: {
        id: 'projectEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    projectDestroy: {
        id: 'projectDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    projectRead: {
        id: 'projectRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    projectAutocomplete: {
        id: 'projectAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    itemImport: {
        id: 'itemImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    itemCreate: {
        id: 'itemCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.itemImages, Storage.itemProductionReadyFiles, Storage.itemOtherFiles]
    },
    itemEdit: {
        id: 'itemEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.itemImages, Storage.itemProductionReadyFiles, Storage.itemOtherFiles]
    },
    itemDestroy: {
        id: 'itemDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: [Storage.itemImages, Storage.itemProductionReadyFiles, Storage.itemOtherFiles]
    },
    itemRead: {
        id: 'itemRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    itemAutocomplete: {
        id: 'itemAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    supplierImport: {
        id: 'supplierImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    supplierCreate: {
        id: 'supplierCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    supplierEdit: {
        id: 'supplierEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    supplierDestroy: {
        id: 'supplierDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    supplierRead: {
        id: 'supplierRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    supplierAutocomplete: {
        id: 'supplierAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    quoteImport: {
        id: 'quoteImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    quoteCreate: {
        id: 'quoteCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    quoteEdit: {
        id: 'quoteEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    quoteDestroy: {
        id: 'quoteDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    quoteRead: {
        id: 'quoteRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    quoteAutocomplete: {
        id: 'quoteAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    orderImport: {
        id: 'orderImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    orderCreate: {
        id: 'orderCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    orderEdit: {
        id: 'orderEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    orderDestroy: {
        id: 'orderDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    orderRead: {
        id: 'orderRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    orderAutocomplete: {
        id: 'orderAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    invoiceImport: {
        id: 'invoiceImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    invoiceCreate: {
        id: 'invoiceCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    invoiceEdit: {
        id: 'invoiceEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    invoiceDestroy: {
        id: 'invoiceDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    invoiceRead: {
        id: 'invoiceRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    invoiceAutocomplete: {
        id: 'invoiceAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },

    specTemplateImport: {
        id: 'specTemplateImport',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    specTemplateCreate: {
        id: 'specTemplateCreate',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    specTemplateEdit: {
        id: 'specTemplateEdit',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    specTemplateDestroy: {
        id: 'specTemplateDestroy',
        allowedRoles: [UserRole.Admin],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise],
        allowedStorage: []
    },
    specTemplateRead: {
        id: 'specTemplateRead',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    },
    specTemplateAutocomplete: {
        id: 'specTemplateAutocomplete',
        allowedRoles: [UserRole.Admin, UserRole.Custom],
        allowedPlans: [PlanTenant.Free, PlanTenant.Growth, PlanTenant.Enterprise]
    }
};
